'use strict';

bbw.guest.AdminLoginCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', '$q', 'rpcClient', 'bbw.RedirectSvc', '$sce'],

    /**
     * @type {ngtk.rpcClient.Client}
     */
    _rpcClient: undefined,

    /**
     * @type {ng.$sce}
     */
    $sce: null,

    _init: function() {
        this.$scope.user = {};
        this.$scope.user_ = {};
        this.$scope.ctrlMode = {};
        this.setLoginMode();
    },

    setLoginMode: function() {
        this._setMode('login');
    },

    setForgotPasswordMode: function() {
        delete this.$scope.user_.error;
        this._setMode('forgotPassword');
    },

    setForgotPasswordRequestSentMode: function() {
        this._setMode('forgotPasswordRequestSent');
    },

    isForgotPasswordMode: function() {
        return this._isMode('forgotPassword') || this._isMode('forgotPasswordRequestSent');
    },

    setConfigureTotpMode: function() {
        this._setMode('configureTotp');
    },

    setOtpMode: function() {
        this._setMode('otp');
    },

    setSuccessMode: function() {
        this._setMode('success');
    },

    _isMode: function(mode) {
        return this.$scope.ctrlMode[mode];
    },

    _setMode: function(mode) {
        var newMode = {};
        newMode[mode] = true;
        ngtk.tools.object.replace(this.$scope.ctrlMode, newMode);
    },

    submit: function() {
        delete this.$scope.user_.error;
        this.$scope.user_.processing = true;
        if (this._isMode('forgotPassword')) {
            return this._doForgotPassword();
        } else {
            return this._doLogin();
        }
    },

    _doForgotPassword: function() {
        return this._rpcClient.post('admin/password-reset-request', this.$scope.user).
            execute().
            then(function(response) {
                if (!response.success) {
                    this._handleResponseError({});
                } else {
                    this.setForgotPasswordRequestSentMode();
                }
            }.bind(this)).
            catch(function(err) {
                this._handleResponseError(err);
            }.bind(this)).
            finally(function() {
                delete this.$scope.user_.processing;
            }.bind(this));
    },

    _doLogin: function() {
        return this._rpcClient.post('admin/login', this.$scope.user).
            execute().
            then(function(response) {
                this._handleLoginResponse(response);
            }.bind(this)).
            catch(function(err) {
                this._handleResponseError(err);
            }.bind(this)).
            finally(function() {
                delete this.$scope.user_.processing;
            }.bind(this));
    },

    _handleLoginResponse: function(response) {
        if (response.success) {
            this.setSuccessMode();
            this._bbwRedirectSvc.redirect(response.redirect);
        } else if (response.continue) {
            delete this.$scope.user.confirm_totp;
            this.$scope.user.otp = '';
            this.setOtpMode();
        } else if (response.configure_totp) {
            this.$scope.configure_totp = response.configure_totp;
            this.$scope.configure_totp = {
                secret: response.configure_totp.secret,
                url: this.$sce.trustAsResourceUrl(response.configure_totp.qr_code_url)
            };
            this.setConfigureTotpMode();
        } else {
            this._handleResponseError({error: undefined});
        }
    },

    _handleResponseError: function(response) {
        this.$scope.user_.error = response.error || 'internal_error';
    }

});
